import { render, staticRenderFns } from "./Shengming.vue?vue&type=template&id=17cc8e07&scoped=true&"
import script from "./Shengming.vue?vue&type=script&lang=js&"
export * from "./Shengming.vue?vue&type=script&lang=js&"
import style0 from "./Shengming.vue?vue&type=style&index=0&id=17cc8e07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cc8e07",
  null
  
)

export default component.exports